export const ensureLeadingSlash = (url: string) => (url.startsWith('/') ? url : '/' + url)